module.exports = __webpack_public_path__ + "img/PR1.92869195.png";